import { render, staticRenderFns } from "./GeneralConfiguration.vue?vue&type=template&id=7819b418&scoped=true&"
import script from "./GeneralConfiguration.vue?vue&type=script&lang=js&"
export * from "./GeneralConfiguration.vue?vue&type=script&lang=js&"
import style0 from "./GeneralConfiguration.vue?vue&type=style&index=0&id=7819b418&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7819b418",
  null
  
)

export default component.exports